/**
 * Stable Cache Storage key for a media URL.
 *
 * Workspace-upload URLs are R2-presigned: the object path is stable but the
 * query string (X-Amz-Signature &c.) rotates on every sync. Keying the media
 * cache by the full URL would invalidate every upload whenever the signature
 * rotates — a full re-download roughly daily at long offline horizons. So
 * presigned URLs are cached under their query-less form; the service worker
 * matches those requests with `ignoreSearch`.
 *
 * Catalogue/CDN URLs (no signature) keep their exact URL: their query
 * strings, when present, are meaningful.
 */
export function mediaCacheUrlKey(url: string): string {
  if (!url.includes("X-Amz-Signature")) return url;
  const q = url.indexOf("?");
  return q === -1 ? url : url.slice(0, q);
}

/** Whether the SW should ignore the query string when cache-matching. */
export function isPresignedMediaUrl(url: string): boolean {
  return url.includes("X-Amz-Signature");
}
